import {
  Message,
} from '@/types/internal'
import {
  CalendarEntry,
  Employee,
  Project,
  SchedulingBoard
} from '@/types/descript_kundenverwaltung_rest'

/**
 * Current State of the Vue App
 */
export interface State {
  immediateAlerts: Array<Message>,
  pendingAlerts: Array<Message>,
  employees: Array<Employee>,
  calendarEntries: Array<CalendarEntry>,
  projects: Array<Project>,
  schedulingBoards: Array<SchedulingBoard>,
  selectedBoard: SchedulingBoard
}

export const emptySelectedBoard = {
  id: 0,
  last_updated: "",
  principal: {
    id: 0,
    name: "",
    slug: ""
  }
}

export function getEmptyState (): State {
  return {
    immediateAlerts: [],
    pendingAlerts: [],
    employees: [],
    calendarEntries: [],
    projects: [],
    schedulingBoards: [],
    selectedBoard: emptySelectedBoard
  }
}
